export default "__VITE_ASSET__B3lqKo_E__"